import { render, staticRenderFns } from "./SubTitle6.vue?vue&type=template&id=0acf37e8&scoped=true&"
import script from "./SubTitle6.vue?vue&type=script&lang=js&"
export * from "./SubTitle6.vue?vue&type=script&lang=js&"
import style0 from "./SubTitle6.vue?vue&type=style&index=0&id=0acf37e8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acf37e8",
  null
  
)

export default component.exports